/* RK Threads — Windows 95 "Welcome to Windows" login customizer.
   Customer types a username; OK saves it to properties[Username] and
   programmatically clicks Add to Cart. Cancel clears the input. */

console.log("[win95-login] script tag loaded, build:", "2026-05-12.4");

(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    console.log("[win95-login] DOM ready, bootstrapping...");
    const root = document.getElementById("win95-login-root");
    console.log("[win95-login] #win95-login-root found?", !!root);
    if (!root || root.dataset.bootstrapped === "1") {
      console.warn("[win95-login] bootstrap skipped (root missing or already bootstrapped)");
      return;
    }
    root.dataset.bootstrapped = "1";

    const cartFormSelector = root.dataset.cartFormSelector || "product-form form, form[action^='/cart/add']";
    const maxLength = parseInt(root.dataset.maxLength, 10) || 20;

    const input = root.querySelector("#win95-username-input");
    const okButton = root.querySelector("#win95-login-save");
    const cancelButton = root.querySelector("#win95-login-cancel");
    console.log("[win95-login] elements found — input:", !!input, "okButton:", !!okButton, "cancelButton:", !!cancelButton);
    const errorEl = root.querySelector(".win95-login-error");
    const loadingOverlay = root.querySelector("#win95-login-loading");
    const savedDialog = root.querySelector("#win95-login-saved-dialog");

    const VALID = /^[A-Za-z0-9 ]+$/;

    // Inject hidden Username input into all cart forms.
    // The <template> is a SIBLING of #win95-login-root (not a descendant),
    // so we search the whole document, not root.
    const tpl = document.getElementById("win95-login-prop-template");
    if (tpl && tpl.content) {
      document.querySelectorAll(cartFormSelector).forEach((form) => {
        tpl.content.childNodes.forEach((node) => {
          if (node.nodeType === 1 && !form.querySelector('input[data-prop="username"]')) {
            form.appendChild(node.cloneNode(true));
          }
        });
      });
    } else {
      console.warn("[win95-login] prop template not found — username will be set defensively at submit time");
    }

    // Disable native Add-to-Cart until OK is pressed.
    setAddToCart(false);
    document.querySelectorAll(cartFormSelector).forEach((form) => {
      form.addEventListener("submit", (e) => {
        const userInput = form.querySelector('input[data-prop="username"]');
        if (!userInput || !userInput.value) {
          e.preventDefault();
          e.stopPropagation();
          showInlineError("Please type a user name and press OK first.");
        }
      });
    });

    const showInlineError = (msg) => {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    };
    const hideInlineError = () => {
      if (errorEl) errorEl.hidden = true;
    };
    const showLoading = (show) => {
      if (loadingOverlay) loadingOverlay.hidden = !show;
    };
    const showSavedDialog = (show) => {
      if (savedDialog) savedDialog.hidden = !show;
    };

    const validate = () => {
      const val = input.value.trim();
      if (!val) {
        showInlineError("Please enter a user name.");
        return null;
      }
      if (val.length > maxLength) {
        showInlineError("Maximum " + maxLength + " characters.");
        return null;
      }
      if (!VALID.test(val)) {
        showInlineError("Only letters, numbers, and spaces allowed.");
        return null;
      }
      hideInlineError();
      return val;
    };

    const updateEnabled = () => {
      const has = input.value.trim().length > 0;
      okButton.disabled = !has;
    };

    input.addEventListener("input", () => {
      hideInlineError();
      updateEnabled();
    });

    if (cancelButton) {
      cancelButton.addEventListener("click", () => {
        input.value = "";
        hideInlineError();
        updateEnabled();
        document.querySelectorAll(cartFormSelector).forEach((form) => {
          const userInput = form.querySelector('input[data-prop="username"]');
          if (userInput) userInput.value = "";
        });
        setAddToCart(false);
      });
    }

    async function submitCartAdd(form, username) {
      const formData = new FormData(form);
      // Defensive: ensure the property is set even if the hidden input
      // wasn't picked up by FormData for some reason.
      if (!formData.has("properties[Username]")) {
        formData.set("properties[Username]", username);
      }
      // Defensive: if `id` somehow isn't set, try the URL `?variant=`.
      if (!formData.has("id") || !formData.get("id")) {
        const u = new URL(window.location.href);
        const v = u.searchParams.get("variant");
        if (v) formData.set("id", v);
      }
      console.log("[win95-login] POST /cart/add.js — id =", formData.get("id"), "Username =", formData.get("properties[Username]"));

      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Accept": "application/json",
        },
        credentials: "same-origin",
      });
      console.log("[win95-login] /cart/add.js status:", res.status);
      return res;
    }

    okButton.addEventListener("click", async () => {
      console.log("[win95-login] OK button clicked. disabled=", okButton.disabled);
      if (okButton.disabled) return;
      const username = validate();
      if (!username) return;

      okButton.disabled = true;
      showLoading(true);

      try {
        const form = document.querySelector(cartFormSelector);
        console.log("[win95-login] form found:", !!form, form);
        if (!form) throw new Error("No product form found on the page.");

        const userInput = form.querySelector('input[data-prop="username"]');
        if (userInput) userInput.value = username;

        await new Promise((r) => setTimeout(r, 500));

        // Try once, retry once on network or 5xx.
        let res;
        try {
          res = await submitCartAdd(form, username);
        } catch (netErr) {
          console.warn("[win95-login] first attempt threw, retrying once:", netErr);
          await new Promise((r) => setTimeout(r, 200));
          res = await submitCartAdd(form, username);
        }
        if (res.status >= 500) {
          console.warn("[win95-login] 5xx, retrying once");
          await new Promise((r) => setTimeout(r, 200));
          res = await submitCartAdd(form, username);
        }

        if (!res.ok) {
          const errBody = await res.json().catch(() => ({}));
          console.error("[win95-login] cart/add rejected:", errBody);
          throw new Error(errBody.description || errBody.message || `Add to cart failed (${res.status}).`);
        }

        const cartLine = await res.json().catch(() => null);
        console.log("[win95-login] added to cart:", cartLine);

        // Notify the theme + Rebuy that the cart changed. Whichever cart
        // drawer is listening will open / refresh.
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: cartLine }));
        document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.open === "function") {
          window.Rebuy.SmartCart.open();
        }
        showLoading(false);
      } catch (err) {
        console.error("[win95-login] add-to-cart failed:", err);
        const msg = err && err.message ? err.message : "Couldn't add to cart. Please try again.";
        showInlineError(msg);
        showLoading(false);
      } finally {
        updateEnabled();
      }
    });

    function setAddToCart(enable) {
      document.querySelectorAll(cartFormSelector).forEach((form) => {
        form.querySelectorAll('button[type="submit"], [name="add"]').forEach((btn) => {
          btn.disabled = !enable;
          if (enable) {
            btn.removeAttribute("aria-disabled");
          } else {
            btn.setAttribute("aria-disabled", "true");
          }
        });
      });
    }

    // ===== Solitaire modal (procrastinate) =====
    const procButton = document.getElementById("win95-login-procrastinate");
    const solitaireModal = document.getElementById("win95-solitaire-modal");
    const solitaireFrame = document.getElementById("win95-solitaire-frame");
    const solitaireLoading = solitaireModal ? solitaireModal.querySelector(".win95-solitaire-loading") : null;
    const solitaireFallback = solitaireModal ? solitaireModal.querySelector(".win95-solitaire-fallback") : null;
    const solitaireWindow = solitaireModal ? solitaireModal.querySelector(".win95-solitaire-window") : null;
    const solitaireClose = solitaireModal ? solitaireModal.querySelector("[data-solitaire-close]") : null;
    const solitaireFs = solitaireModal ? solitaireModal.querySelector("[data-solitaire-fullscreen]") : null;
    // Read the asset URL from the iframe's data-src so we can use Liquid's
    // asset_url at render time (which gives us /cdn/shop/t/<X>/assets/solitaire.html).
    const SOLITAIRE_URL = solitaireFrame ? (solitaireFrame.dataset.src || "") : "";

    function openSolitaire() {
      if (!solitaireModal) return;
      // Lazy-load the game on first open.
      if (!solitaireFrame.src) {
        solitaireFrame.src = SOLITAIRE_URL;
        if (solitaireLoading) solitaireLoading.hidden = false;
        if (solitaireFallback) solitaireFallback.hidden = true;
        let loaded = false;
        solitaireFrame.addEventListener("load", () => {
          loaded = true;
          if (solitaireLoading) solitaireLoading.hidden = true;
        }, { once: true });
        // If the iframe never fires `load` within 8s, assume it was
        // blocked (CSP / X-Frame-Options) and show the fallback.
        setTimeout(() => {
          if (!loaded) {
            if (solitaireLoading) solitaireLoading.hidden = true;
            if (solitaireFallback) solitaireFallback.hidden = false;
          }
        }, 8000);
      }
      solitaireModal.hidden = false;
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }
    function closeSolitaire() {
      if (!solitaireModal) return;
      solitaireModal.hidden = true;
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }

    if (procButton) procButton.addEventListener("click", openSolitaire);
    if (solitaireClose) solitaireClose.addEventListener("click", closeSolitaire);
    if (solitaireModal) {
      solitaireModal.addEventListener("click", (e) => {
        if (e.target === solitaireModal) closeSolitaire();
      });
    }
    if (solitaireFs && solitaireWindow) {
      solitaireFs.addEventListener("click", () => {
        solitaireWindow.classList.toggle("is-fullscreen");
      });
    }
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && solitaireModal && !solitaireModal.hidden) closeSolitaire();
    });
  });
})();
